module.exports = __webpack_public_path__ + "static/exploration-02fd4b9b7c20a846aac62819433191c0.png";